import { createContext, useContext } from 'react';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';

export interface ProfileSelectorContextValue {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onSelectProfile: (id: ServiceVendorId) => void;
}

export const ProfileSelectorContext = createContext<ProfileSelectorContextValue | null>(null);

export function useProfileSelectorContext() {
  const context = useContext(ProfileSelectorContext);
  if (!context) {
    throw new Error('useProfileSelectorContext must be used within ProfileSelector');
  }
  return context;
}
